import { useAuth } from './AuthContext';

export const ADMIN_EMAIL = 'galloan224@gmail.com';

export function useIsAdmin() {
  const { user } = useAuth();
  if (!user) return false;
  if (user.email !== ADMIN_EMAIL) return false;
  if (user.emailVerified !== true) return false;
  return true;
}
